import { Attractor } from "./Attractor";
export async function loadExternalAttractInteraction(engine) {
    await engine.addInteractor("externalAttract", (container) => new Attractor(engine, container));
}
export * from "./Options/Classes/Attract";
export * from "./Options/Interfaces/IAttract";
